import {
  Button,
  Input,
  Select,
  HStack,
  VStack,
  Box,
  Text,
  useToast
} from '@chakra-ui/react';
import { FaCar } from "react-icons/fa";
import { useForm } from 'react-hook-form';
import { BoxTitle } from '@/components/BoxTitle';
import { ModalAlert } from '@/components/ModalStyled/Modal';
import { FaTruckMoving } from "react-icons/fa";

interface TransportadoraFormData {
  transportadora: string;
  tipoPessoa: string;
  cpfCnpj: string;
  nomeFantasia: string;
  tipo: string;
  situacao: string;
  ie: string;
  cep: string;
  endereco: string;
  numero: string;
  bairro: string;
  cidade: string;
  uf: string;
  box: string;
  leadTime: string;
  email: string;
  ativo: string;
}

interface ModalTransportadoraProps {
  isOpen: boolean;
  onClose: () => void;
  handleAddTransportadora: (formData: TransportadoraFormData) => void;
}

const ModalTransportadora: React.FC<ModalTransportadoraProps> = ({ isOpen, onClose, handleAddTransportadora }) => {
  const toast = useToast();
  const {
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
    reset
  } = useForm<TransportadoraFormData>({
    defaultValues: {
      transportadora: '',
      tipoPessoa: '',
      cpfCnpj: '',
      nomeFantasia: '',
      tipo: '',
      situacao: '',
      ie: '',
      cep: '',
      endereco: '',
      numero: '',
      bairro: '',
      cidade: '',
      uf: '',
      box: '',
      leadTime: '',
      email: '',
      ativo: 'Ativo'
    }
  });

  const onSubmit = async (data: TransportadoraFormData) => {
    const missingFields: any = [];

    Object.entries(data).forEach(([key, value]) => {
      if (!value) missingFields.push(key);
    });

    if (missingFields.length > 0) {
      toast({
        title: missingFields.length === 1
          ? `O campo ${missingFields[0]} é obrigatório.`
          : "Faltam campos obrigatórios a serem preenchidos.",
        status: "error",
        isClosable: true,
      });
      return;
    }

    handleAddTransportadora(data);
    toast({
      title: "Transportadora adicionada com sucesso!",
      status: "success",
      isClosable: true,
    });
    reset();
    onClose();
  };


  return (
    <ModalAlert
      isOpen={isOpen}
      onClose={onClose}
      size='3xl'
      title={
        <Text fontSize={'xl'} ml={2}>Transportadora</Text>
      }
      body={
        <Box as="form" onSubmit={handleSubmit(onSubmit)}>
          <VStack spacing={4} align="stretch">
            <HStack>
              <BoxTitle title="Transportadora">
                <Input name="transportadora" value={watch("transportadora")} onChange={(e) => setValue("transportadora", e.target.value)} placeholder="Insira o nome de uma transportadora" />
              </BoxTitle>
              <BoxTitle title="Ativo">
                <Select name="ativo" value={watch("ativo")} onChange={(e) => setValue("ativo", e.target.value)}>
                  <option>Ativo</option>
                  <option>Inativo</option>
                </Select>
              </BoxTitle>
            </HStack>
            <HStack>
              <HStack w={'30%'}>
                <BoxTitle title="Tipo Pessoa">
                  <Select name="tipoPessoa" value={watch("tipoPessoa")} onChange={(e) => setValue("tipoPessoa", e.target.value)} placeholder="Selecione um tipo" />
                </BoxTitle>
              </HStack>
              <HStack w={'30%'}>
                <BoxTitle title="CPF/CNPJ">
                  <Input name="cpfCnpj" value={watch("cpfCnpj")} onChange={(e) => setValue("cpfCnpj", e.target.value)} placeholder="Digite um CPF/CNPJ" />
                </BoxTitle>
              </HStack>
              <BoxTitle title="Nome Fantasia">
                <Input name="nomeFantasia" value={watch("nomeFantasia")} onChange={(e) => setValue("nomeFantasia", e.target.value)} placeholder="Digite um nome fantasia" />
              </BoxTitle>
            </HStack>
            <HStack>
              <HStack w={'30%'}>
                <BoxTitle title="Tipo">
                  <Select name="tipo" value={watch("tipo")} onChange={(e) => setValue("tipo", e.target.value)} placeholder="Selecione um tipo" />
                </BoxTitle>
              </HStack>
              <HStack w={'30%'}>
                <BoxTitle title="Situação">
                  <Select name="situacao" value={watch("situacao")} onChange={(e) => setValue("situacao", e.target.value)} placeholder="Selecione uma situação" />
                </BoxTitle>
              </HStack>
              <BoxTitle title="IE">
                <Input name="ie" value={watch("ie")} onChange={(e) => setValue("ie", e.target.value)} placeholder="Digite uma inscrição estadual" />
              </BoxTitle>
            </HStack>
            <HStack>
              <HStack w={'20%'}>
                <BoxTitle title="CEP">
                  <Input name="cep" value={watch("cep")} onChange={(e) => setValue("cep", e.target.value)} placeholder="Digite CEP" />
                </BoxTitle>
              </HStack>
              <BoxTitle title="Endereço">
                <Input name="endereco" value={watch("endereco")} onChange={(e) => setValue("endereco", e.target.value)} placeholder="Digite um endereço" />
              </BoxTitle>
              <HStack w={'20%'}>
                <BoxTitle title="N°">
                  <Input name="numero" value={watch("numero")} onChange={(e) => setValue("numero", e.target.value)} placeholder="Número" />
                </BoxTitle>
              </HStack>
            </HStack>
            <HStack>
              <HStack w={'40%'}>
                <BoxTitle title="Bairro">
                  <Input name="bairro" value={watch("bairro")} onChange={(e) => setValue("bairro", e.target.value)} placeholder="Digite um bairro" />
                </BoxTitle>
              </HStack>
              <BoxTitle title="Cidade / IBGE">
                <Select name="cidade" value={watch("cidade")} onChange={(e) => setValue("cidade", e.target.value)} placeholder="Selecione uma cidade" />
              </BoxTitle>
              <HStack w={'20%'}>
                <BoxTitle title="UF">
                  <Input name="uf" value={watch("uf")} onChange={(e) => setValue("uf", e.target.value)} placeholder="UF" />
                </BoxTitle>
              </HStack>
            </HStack>
            <HStack>
              <HStack w={'25%'}>
                <BoxTitle title="Box">
                  <Select name="box" value={watch("box")} onChange={(e) => setValue("box", e.target.value)} placeholder="Selecione box" />
                </BoxTitle>
              </HStack>
              <HStack w={'25%'}>
                <BoxTitle title="Lead Time">
                  <Input name="leadTime" value={watch("leadTime")} onChange={(e) => setValue("leadTime", e.target.value)} placeholder="Digite um lead time" />
                </BoxTitle>
              </HStack>
              <BoxTitle title="E-mail">
                <Input name="email" value={watch("email")} onChange={(e) => setValue("email", e.target.value)} placeholder="Digite um e-mail" />
              </BoxTitle>
            </HStack>
          </VStack>
        </Box>
      }
      footer={
        <Button colorScheme="blue" onClick={handleSubmit(onSubmit)}>
          Confirmar
        </Button>
      }
    />
  );
};

export default ModalTransportadora;
